var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.5C24.7532 32.5 32 25.2371 32 16.5C32 7.74681 24.7376 0.5 15.9844 0.5C7.24731 0.5 0 7.74681 0 16.5C0 25.2371 7.26287 32.5 16 32.5ZM15.9844 19.4174C15.1688 19.4174 14.714 18.9626 14.6984 18.1314L14.4941 9.58248C14.4786 8.75073 15.0904 8.1549 15.9689 8.1549C16.8317 8.1549 17.4748 8.76629 17.4592 9.59804L17.2393 18.1314C17.2238 18.9782 16.769 19.4174 15.9844 19.4174ZM15.9844 24.6724C15.0433 24.6724 14.2276 23.9195 14.2276 22.9939C14.2276 22.0683 15.0277 21.2998 15.9844 21.2998C16.9412 21.2998 17.7413 22.0527 17.7413 22.9939C17.7413 23.9351 16.9256 24.6724 15.9844 24.6724Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/ExclamationMark.623fbcd63a5158ae0d570523e9d214d1.svg";
export { ForwardRef as ReactComponent };